import React, { useEffect, useState } from "react";
import "./notificationsBoard.scss";

import SearchInput from "../../components/searchInput/SearchInput";
import HeaderBar from "../../components/headerBar/HeaderBar";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import SingleNotification from "../../components/singleNotification/SingleNotification";
import ContentMessage from "../notifications/components/contentMessage/ContentMessage";

import { useNavigate, useParams } from "react-router-dom";
import { setGlobalState } from "../../utils/state";
import { t } from "i18next";
import {
  getAssociationNotificationsSendWS,
  getSingleNotificationsWS,
} from "./api/notificationsBoardApi";
import { isEmpty } from "../../utils/validation";
import { Col, Row } from "react-bootstrap";
import { useScreenSize } from "../../ScreenSizeContext";

const NotificationsBoard = () => {
  const navigate = useNavigate();

  const isPC = useScreenSize();
  const { id_association } = useParams();

  const [search, setSearch] = useState("");

  const [notifications, setNotifications] = useState([]);
  const [filterNotifications, setFilterNotifications] = useState([]);

  const [dataNotification, setDataNotification] = useState({});
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getAssociationNotificationsSendWS({ id_association })
      .then((res) => {
        setNotifications(res);
        setFilterNotifications(res);
      })
      .catch((err) => console.error(err));
  }, [id_association]);

  const searchFunction = () => {
    if (!isEmpty(search)) {
      setFilterNotifications(
        notifications.filter((notification) => {
          const title = notification.title?.toLowerCase() || "";
          const body = notification.body?.toLowerCase() || "";

          return (
            title.includes(search.toLowerCase()) ||
            body.includes(search.toLowerCase())
          );
        })
      );
    } else {
      setFilterNotifications(notifications);
    }
  };

  const handleClickNotification = ({ id, id_event, question }) => {
    setSelected(id);
    getSingleNotificationsWS({
      id_notification: id,
      id_association,
      id_event,
      question,
    })
      .then((res) => {
        setDataNotification(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return !isPC /*MOBILE */ ? (
    <>
      <HeaderBar
        title={t("notifications_board.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <div className="notifications-board-container container-responsive mt-2">
        <SearchInput
          search={search}
          setSearch={setSearch}
          searchFunction={searchFunction}
        />
        <div className="notifications-list">
          {!isEmpty(filterNotifications)
            ? filterNotifications.map((item) => (
                <SingleNotification
                  key={item.id}
                  id={item.id}
                  id_event={item.id_event}
                  image_type={item.image}
                  image={item.image}
                  title={item.title}
                  body={item.body}
                  datetime_sending={item.datetime_sending}
                  question={item.question ?? 0}
                  handleClick={() =>
                    navigate(
                      `/notifications/${
                        item.id
                      }?admin=${id_association}&id_event=${item.id_event ?? 0}`
                    )
                  }
                  displayed={true}
                />
              ))
            : null}
        </div>
      </div>
      <VoidSpace />
    </>
  ) : (
    /*Visualizzazione da PC */
    <>
      <HeaderBar
        title={t("notifications_board.title")}
        back={true}
        path={"/dashboard/" + id_association}
      />
      <div className="notifications-board-container mt-2">
        <Row>
          <Col lg={6}>
            <Row sm={1} md={1} lg={1} xl={1}>
              <Col
                sm={12}
                md={12}
                lg={12}
                xl={12}
                className="d-flex justify-content-center"
              >
                <SearchInput
                  search={search}
                  setSearch={setSearch}
                  searchFunction={searchFunction}
                />
              </Col>
            </Row>
            <div className="notifications-list">
              <Row sm={1} md={1} lg={1} xl={1} className="g-2 mt-2">
                {!isEmpty(filterNotifications)
                  ? filterNotifications.map((item) => (
                      <Col sm={12} md={12} lg={12} xl={12} key={item.id}>
                        <SingleNotification
                          id={item.id}
                          id_event={item.id_event ?? 0}
                          image_type={item.image}
                          image={item.image}
                          title={item.title}
                          body={item.body}
                          datetime_sending={item.datetime_sending}
                          displayed={true}
                          question={item.question ?? 0}
                          handleClick={handleClickNotification}
                        />
                      </Col>
                    ))
                  : null}
              </Row>
            </div>
          </Col>
          <Col lg={6} className="d-flex justify-content-center">
            {!isEmpty(selected) && !isEmpty(dataNotification) ? (
              <ContentMessage dataNotification={dataNotification} />
            ) : (
              <div></div>
            )}
          </Col>
        </Row>
      </div>
      <VoidSpace />
    </>
  );
};

export default NotificationsBoard;
